import React from 'react';
import { Box, Divider, Drawer, IconButton, Stack, Typography } from '@mui/material';
import Close from '@mui/icons-material/Close';

// Direct imports: the @organisms barrel re-exports billingDetails, which
// renders this file, so going through it would be circular.
import CrmCredentialPanel from '../../../crmCredential';
import BillingModelPanel from '../../../billingModel';

interface AccountSettingsDrawerProps {
  open: boolean;
  onClose: () => void;
  companyId: string;
  /** A Street sync added teams or users — the page's tables should refetch. */
  onSynced?: () => void;
}

/**
 * Superadmin-only account configuration — the CRM token and the billing model.
 *
 * Both are set once per agency and rarely touched again, so they live behind
 * the header's Settings button instead of taking the top of the page.
 */
const AccountSettingsDrawer: React.FC<AccountSettingsDrawerProps> = ({
  open,
  onClose,
  companyId,
  onSynced
}) => (
  <Drawer anchor="right" open={open} onClose={onClose}>
    <Box sx={{ width: { xs: '100vw', sm: 560 }, maxWidth: '100vw' }}>
      <Stack
        direction="row"
        alignItems="center"
        sx={{ px: 2, py: 1.5, position: 'sticky', top: 0, bgcolor: 'background.paper', zIndex: 1 }}
      >
        <Typography variant="h6" sx={{ flex: 1 }}>
          Account settings
        </Typography>
        <IconButton aria-label="Close settings" onClick={onClose}>
          <Close />
        </IconButton>
      </Stack>
      <Divider />
      <Stack spacing={2} sx={{ p: 2 }}>
        <CrmCredentialPanel companyId={companyId} onSynced={onSynced} />
        <BillingModelPanel companyId={companyId} />
      </Stack>
    </Box>
  </Drawer>
);

export default AccountSettingsDrawer;
